export default __webpack_public_path__ + "static/media/sijil-suruhanjaya-tenaga.909b3b08.png";